import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import GridCheckbox from './GridCheckbox'
import { useTeamName } from '../hooks/utils-functions'
import { titlesIscrizioni, TIPOLOGIE_SPOSTAMENTO } from '../settings/settings'

const DialogSpostamentoInfo = ({
  open,
  handleClose,
  triggerFunction,
  spostamentoInit,
  mode,
}) => {
  const [spostamento, setSpostamento] = useState()

  const squadraCasaName = useTeamName(spostamento?.squadraCasaID)
  const squadraTrasfertaName = useTeamName(spostamento?.squadraTrasfertaID)

  useEffect(() => {
    setSpostamento(spostamentoInit)
  }, [spostamentoInit])

  const GridElement = ({ label, field, mapping, large = false }) => {
    return (
      <Grid size={{ xs: 12, md: large ? 12 : 6 }}>
        <center>
          {label}&nbsp;
          <b>
            {mapping
              ? mapping(spostamento[field])
              : spostamento[field] ||
                (['data', 'nuovaData'].includes(field) && 'non definita') ||
                (['ora', 'nuovaOra'].includes(field) && 'non definito') ||
                '?'}
          </b>
        </center>
      </Grid>
    )
  }

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(spostamento)}
      title={titlesIscrizioni.titleSpostamentoInfo}
      textConfirm={mode === 'reply' && 'Conferma'}
      maxWidth='md'
    >
      <Grid container spacing={3} sx={{ width: '100%' }}>
        {!spostamento ? (
          'Spostamento non trovato.'
        ) : (
          <Grid container alignItems='center' sx={{ width: '100%' }}>
            {mode === 'reply' && (
              <Grid size={12}>
                Il presente modulo permette di accettare o rifiutare le
                richieste di spostamento ricevute. La compilazione del modulo
                genera una mail di conferma alla squadra avversaria e
                l'aggiornamento immediato del calendario.
              </Grid>
            )}
            <GridElement label='Gara' field='numeroGara' />
            <GridElement label='Categoria' field='categoria' />
            <GridElement
              label='Squadra in casa'
              field='squadraCasaID'
              mapping={() => squadraCasaName}
            />
            <GridElement
              label='Squadra in trasferta'
              field='squadraTrasfertaID'
              mapping={() => squadraTrasfertaName}
            />
            <GridElement
              label={
                TIPOLOGIE_SPOSTAMENTO[spostamento.tipologia]?.requiresNewDate
                  ? 'Vecchia data'
                  : 'Data'
              }
              field='data'
            />
            <GridElement
              label={
                TIPOLOGIE_SPOSTAMENTO[spostamento.tipologia]?.requiresNewTime
                  ? 'Vecchio orario'
                  : 'Orario'
              }
              field='ora'
            />
            <GridElement
              label=''
              field='tipologia'
              mapping={x => TIPOLOGIE_SPOSTAMENTO[x]?.label}
              large
            />
            {TIPOLOGIE_SPOSTAMENTO[spostamento.tipologia]?.requiresNewDate && (
              <GridElement label='Nuova data' field='nuovaData' />
            )}
            {TIPOLOGIE_SPOSTAMENTO[spostamento.tipologia]?.requiresNewTime && (
              <GridElement label='Nuovo orario' field='nuovaOra' />
            )}
            {!!spostamento.note && (
              <GridElement
                label='Note della squadra richiedente'
                field='note'
                large
              />
            )}
            {mode === 'view' && (
              <GridElement
                label='Stato'
                field='acceptedBySocietaRisposta'
                mapping={x =>
                  x === true
                    ? 'Accettato'
                    : x === false
                      ? 'Rifiutato'
                      : 'In sospeso'
                }
                large
              />
            )}
            {mode === 'reply' && (
              <>
                <GridCheckbox
                  label='Accetto lo spostamento.'
                  value={!!spostamento?.checkAccept}
                  onChange={(_, x) =>
                    setSpostamento({
                      ...spostamento,
                      checkAccept: x,
                      checkReject: undefined,
                    })
                  }
                />
                <GridCheckbox
                  label='Rifiuto lo spostamento.'
                  value={!!spostamento?.checkReject}
                  onChange={(_, x) =>
                    setSpostamento({
                      ...spostamento,
                      checkReject: x,
                      checkAccept: undefined,
                    })
                  }
                />
              </>
            )}
          </Grid>
        )}
      </Grid>
    </Dialog>
  )
}

export default DialogSpostamentoInfo
